import React from "react";
import "../../styles/ComponentsStyles/Universal/SuccessModal.style.css";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import CrossBtnIcon from "../../assets/Icons/Universal/CrossIcon.svg";
const SecondModal = ({
  isOpen = false,
  onClose,
  children,
  isCrossBtn = false,
}) => {
  const [modalStatus, setModalStatus] = useState(isOpen);
  useEffect(() => {
    setModalStatus(isOpen);
  }, [isOpen]);

  return (
    <div
      className={`successModal ${
        modalStatus ? "successModalOpen" : "successModalClose"
      }`}
    >
      <div
        className="modalBackground"
        onClick={() => {
          setModalStatus(false);
          onClose();
        }}
      ></div>
      <div className="successModalContent">
        <div className="successModalContentContainer">
          {children}
          {isCrossBtn ? (
            <button
              className="secondModalCloseBtn"
              onClick={() => {
                setModalStatus(false);
                onClose();
              }}
            >
              <img src={CrossBtnIcon} alt="" />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

SecondModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isCrossBtn: PropTypes.bool,
};
export default SecondModal;
